import { render, staticRenderFns } from "./Tuition.vue?vue&type=template&id=1bf3b513"
import script from "./Tuition.vue?vue&type=script&lang=js"
export * from "./Tuition.vue?vue&type=script&lang=js"
import style0 from "./Tuition.vue?vue&type=style&index=0&id=1bf3b513&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Section: require('/app/nuxt/components/Section.vue').default})
